import _isArray from 'lodash/isArray'

const getItemIds = (items: any, cap?: number): number[] => {
  if (!items) return []
  return _isArray(items)
    ? getItemIdsFromArray(cap ? items.slice(0, cap) : items)
    : [Number(items.id)]
}

const getItemIdsFromArray = (items: any[]): number[] =>
  items
    .filter((item: any) => typeof item === 'object')
    .map(({ id }: { id: number }) => id)

export default getItemIds
